export const configAirwayDh = {
  "index": {
    "Type": "JSON",
    "url": "%arinc_data_auth_api_url%/auth/airway",
    "update_interval": 999999,
    "retain": true,
    "cache": true
  },
  "data": {
    "Type": "GeoJSON",
    "url": "%arinc_data_url%/airway/%index%/%z%/%y%/%x%.json",
    "cache": true,
    "Grid": {
      "MinZoom": 4,
      "MaxZoom": 6,
      "download_max": 32,
      "BoundingBox": {
        "West": -180.0,
        "South": -90.0,
        "East": 180.0,
        "North": 90.0
      }
    }
  }
};

export const configAirwayLayer = {
  "Name": "Airway",
  "Renderer": "AirwayLine",
  "Attributes": {
    "min_zoom": 6,
    "features": [
      {
        "selector": {
          "type": "key_value",
          "key": "kind",
          "value": "ITN"
        },
        "style": {
          "default": {
            "type": "line",
            "line_method": "GC",
            "line_color": "#84a3b4",
            "line_width": 1
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "kind",
          "value": "DOM"
        },
        "style": {
          "default": {
            "type" : "line",
            "line_method": "GC",
            "line_color" : "#84a3b4",
            "line_width" : 1
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "kind",
          "value": "OTH"
        },
        "style": {
          "default": {
            "type": "line",
            "line_method": "GC",
            "line_color": "#84a3b4",
            "line_width": 1
          }
        }
      }
    ]
  }
};

export const configAirwayLabelLayer = {
  "Name": "Airway",
  "Renderer": "AirwayLabel",
  "Attributes": {
    "min_zoom": 6,
    "features": [
      {
        "style": {
          "default": {
            "fill_color": "#5050a1",
            "label_color": "#fff",
            "font_size": 10
          }
        }
      }
    ]
  }
};
